<template>
  <div v-if="isDebug" class="debug-indicator">
    <v-chip
      color="warning"
      size="small"
      prepend-icon="mdi-bug"
    >
      DEBUG MODE - Cache Disabled
    </v-chip>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { isDebugMode } from '@/utils/urlParams'

export default {
  setup() {
    const isDebug = ref(false)

    onMounted(() => {
      isDebug.value = isDebugMode()
      if (isDebug.value) {
        console.log('🐛 Debug mode is ENABLED - API caching is disabled')
      }
    })

    return {
      isDebug
    }
  }
}
</script>

<style scoped>
.debug-indicator {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 9999;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}
</style>
